// import Cookies from "js-cookie";
import "./LngBtn.css";
import "flag-icons/css/flag-icons.min.css";
const LngBtn = ({ code, name, country_code, onLngChange, disableLng }) => {
  // const currentLanguageCode = Cookies.get("i18next") || "de";

  return (
    <button className="lngButton" onClick={onLngChange} disabled={disableLng} style={{border: "none"}}>
      <span className={`fi fi-${country_code}`} style={{opacity: disableLng ? 0.5 : 1}}></span>
      {name}
    </button>
  );
};

export default LngBtn;
